import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export const FlameFilled = forwardRef(({ color = "currentColor", size = 24, ...rest }, ref) => {
    const defaultAttrs = {
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: color,
        ref,
        ...rest,
    };
    return (_jsx("svg", { ...defaultAttrs, children: _jsx("path", { clipRule: "evenodd", d: "m10.6173 2.40134c.3737-.15478.8038-.06922 1.0898.21678.6574.65737 1.4805 2.09383 1.8882 3.73033.3408 1.36763.4261 3.01905-.237 4.56655.0209-.005.0384-.0121.0543-.0184.1168-.0467.3263-.1766.6344-.5202.3047-.3398.6648-.84221 1.0937-1.56272.1631-.27385.4469-.45359.7641-.48392.3173-.03032.63.09239.842.3304.5735.64396 1.1254 1.62204 1.5316 2.60674.4041.9794.7216 2.1042.7216 3.0583 0 1.8565-.7375 3.637-2.0503 4.9498-1.3127 1.3127-3.0932 2.0502-4.9497 2.0502s-3.63699-.7375-4.94975-2.0502c-1.31275-1.3128-2.05025-3.0933-2.05025-4.9498 0-2.0094.8681-4.2429 2.28329-5.69735.03235-.03319.0654-.06706.09801-.10047 1.22604-1.25622 2.6187-2.68316 2.6187-5.20216 0-.40446.2436-.76909.6173-.92388z", fill: "currentColor", fillRule: "evenodd" }) }));
});
FlameFilled.displayName = "FlameFilled";
//# sourceMappingURL=FlameFilled.js.map